import React from 'react';
import data from '../../data/anit.json';
import PageTemplate from '../../components/PageTemplate';

function Anti() {
    return <PageTemplate title="Anti Ragging Cell" data={data} />;
}

export default Anti;
